// Risk Alert Modal
// Warning modal for high-risk tasks (RPN >= 500)

import React from 'react';
import { AlertTriangle, X, Activity } from 'lucide-react';
import { riskCalculationService } from '../../services/riskCalculationService';
import Modal from '../ui/Modal';
import './RiskAlertModal.css';

const RiskAlertModal = ({ task, onConfirm, onCancel }) => {
  if (!task || !task.risk_data) return null;

  const riskLevel = riskCalculationService.getRiskLevel(task.risk_data.max_rpn || 0);

  return (
    <Modal
      isOpen={true}
      onClose={onCancel}
      title="High-Risk Task Warning"
      className="risk-alert-modal"
    >
      <div className="risk-alert-content">
        <div className="alert-header">
          <div className="alert-icon critical">
            <AlertTriangle size={32} />
          </div>
          <div className="alert-title">
            <h2>Critical Risk Task</h2>
            <p>This task has been flagged as high-risk and requires immediate attention.</p>
          </div>
        </div>

        <div className="task-info">
          <h3>{task.name}</h3>
          {task.context?.roomName && (
            <p className="task-location">Location: {task.context.roomName}</p>
          )}
        </div>

        <div className="risk-details">
          <div className="risk-stat">
            <div className="stat-label">Maximum RPN</div>
            <div className="stat-value critical">{task.risk_data.max_rpn}</div>
            <div className="stat-level">{riskLevel.level}</div>
          </div>
          
          <div className="risk-stat">
            <div className="stat-label">Average RPN</div>
            <div className="stat-value">{task.risk_data.avg_rpn}</div>
          </div>
          
          <div className="risk-stat">
            <div className="stat-label">Total Risks</div>
            <div className="stat-value">{task.risk_data.risk_count}</div>
          </div>
          
          {task.risk_data.critical_risks && task.risk_data.critical_risks.length > 0 && (
            <div className="critical-risks-section">
              <h4>Critical Risks ({task.risk_data.critical_risks.length})</h4>
              <ul className="risks-list">
                {task.risk_data.critical_risks.slice(0, 5).map((risk, idx) => (
                  <li key={risk.id || idx} className="risk-item">
                    <span className="risk-scenario">{risk.scenario}</span>
                    <span className="risk-rpn">RPN: {risk.rpn}</span>
                  </li>
                ))}
                {task.risk_data.critical_risks.length > 5 && (
                  <li className="risk-more">
                    +{task.risk_data.critical_risks.length - 5} more critical risks
                  </li>
                )}
              </ul>
            </div>
          )}
          
          {task.risk_data.biological_entities && task.risk_data.biological_entities.length > 0 && (
            <div className="biological-entities-section">
              <h4>Biological Entities at Risk</h4>
              <div className="entities-list">
                {task.risk_data.biological_entities.map((entity, idx) => (
                  <span key={entity.id || idx} className="entity-badge">
                    {entity.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="alert-warning">
          <AlertTriangle size={16} />
          <p>
            <strong>Warning:</strong> This task involves critical risks that may impact patient safety.
            Please ensure all safety protocols are followed and use appropriate protective equipment.
          </p>
        </div>

        <div className="modal-actions">
          <button onClick={onCancel} className="btn btn-secondary">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn btn-primary btn-danger">
            <Activity size={16} />
            Proceed with Caution
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RiskAlertModal;



